import type { FC, PropsWithChildren } from "react";
import React from "react";

import { hasValue, isNullish } from "@core/foundation/types";

import { useImmediateEffect } from "@react/foundation/lifecycle";
import { LoadingView } from "@react/foundation/placeholder";
import { toast } from "@react/ui-primitives/extension";

import { isUserToken } from "@platform/core";

import { authSelectors, useAuthStore } from "../state/auth.ts";
import {
  signinOnReturnSelectors,
  useSigninOnReturnStore,
} from "../state/signin-on-return.ts";

import { AuthProvider } from "./AuthProvider.tsx";
import { GoogleSigninButton } from "./GoogleSigninButton.tsx";

export const AuthGuard: FC<PropsWithChildren> = ({ children }) => {
  const authToken = useAuthStore(authSelectors.authToken);

  const error = useSigninOnReturnStore(signinOnReturnSelectors.error);

  const isPending = useSigninOnReturnStore(signinOnReturnSelectors.isPending);

  useImmediateEffect(() => {
    if (isNullish(error)) {
      return;
    }

    toast.error(error);
  }, [error]);

  if (hasValue(authToken) && isUserToken(authToken)) {
    return <AuthProvider authToken={authToken}>{children}</AuthProvider>;
  }

  if (isPending) {
    return <LoadingView />;
  }

  return (
    <div className="flex h-full items-center justify-center">
      <GoogleSigninButton />
    </div>
  );
};
